import styled from '@emotion/styled';

export const SubviewsMenu = styled('ul', { label: 'SubviewsMenu' })`
    display: flex;
    justify-content: flex-end;
    padding: 0;
    margin: 0;
    list-style: none;
`;

export const TelebetButton = styled('button', { label: 'TelebetButton' })`
    order-radius: 0;
    color: #000;
    border: 1px solid #fff;
    background: #CCCCCC;
    padding: 5px 20px;
    font-size: 1.2em;
  
`;

